import { UploadedFiles } from "@portal/BaseComponents/Document/UplodedFiles/UploadedFiles";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Comment_UI_DTO } from "@portal/types/entities/comment";
import { CommentView } from "@sinecycle/growcomponents";
import { Spin } from "antd";
import { filter, map } from "lodash";

interface CommentListProps {
  list: Comment_UI_DTO[];
  loading?: boolean;
}
function CommentList(props: CommentListProps) {
  const { list, loading } = props;

  function transformCommentList() {
    const modifiedlist = filter(list, (value) => !value.private);
    return map(modifiedlist, (comment) => {
      const attachments = map(comment?.attachments, (file) => {
        return (
          <UploadedFiles
            file={file}
            key={file.id}
            closable={false}
            previewType="EXPIRE_LINK"
          />
        );
      });
      return {
        commentId: String(comment.id),
        private: comment.private,
        firstName: comment.created_by?.first_name ?? "",
        lastName: comment.created_by?.last_name,
        role: comment.created_by?.designation,
        comment: comment.comments,
        date: comment.updated_at,
        deletable: false,
        extra: <Flex wrap>{attachments}</Flex>,
        plainText: true,
        hideLink: true,
      };
    });
  }
  const comments = transformCommentList();
  return (
    <Spin spinning={loading} tip="Posting...">
      {comments.length ? (
        <CommentView commentList={comments} />
      ) : (
        <div style={{ height: "40px" }} />
      )}
    </Spin>
  );
}

export { CommentList };
